const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

/**
 * Loads the instructor entitlement contract (tier ∩ role) for portal gating.
 * Pass `orgId` to scope the entitlements to a specific organization (multi-org
 * users / after switching the active org); omit it to use the account default.
 */
export async function fetchInstructorEntitlements(userId, orgId) {
  const url = orgId
    ? `${apiUrl}/api/instructor/entitlements/${userId}?orgId=${encodeURIComponent(orgId)}`
    : `${apiUrl}/api/instructor/entitlements/${userId}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
  });
  if (!response.ok) {
    throw new Error(`Entitlements request failed: ${response.status}`);
  }
  return response.json();
}
